import { BaseLayout } from "./BaseLayout";
import { QueryParameter, Util, Navigation } from "Core";
import { LayoutProvider } from "./LayoutProvider";
import { Page } from "Core/Pages";

export class LayoutHandler {
    private static layout = require("./Templates/Layout.html").default;

    public currentMenuMode: string;
    public currentContentMode: string;

    private menuLayout: BaseLayout;
    private contentLayout: BaseLayout;

    private layoutProvider: LayoutProvider;
    private layout: kendo.Layout;

    constructor(private model: Object) {
        this.layoutProvider = new LayoutProvider();
    }

    initialize(container: JQuery<HTMLElement>): void {
        this.layout = new kendo.Layout(LayoutHandler.layout, {
            model: this.model,
            wrap: false,
            evalTemplate: true,
        });
        this.layout.render(container);

        Navigation.initialize();
    }

    resize(): void {
        if (this.menuLayout) {
            this.menuLayout.resize();
        }
        if (this.contentLayout) {
            this.contentLayout.resize();
        }
    }

    render(page: Page): Promise<void> {
        return page.render(this.layout);
    }

    update(): void {
        let menuMode = "standard";
        let contentMode = "standard";

        let menuModeParam = QueryParameter.get("menuMode");
        if (!Util.stringIsNullOrEmpty(menuModeParam)) {
            menuMode = menuModeParam;
        }
        let contentModeParam = QueryParameter.get("contentMode");
        if (!Util.stringIsNullOrEmpty(contentModeParam)) {
            contentMode = contentModeParam;
        }

        let pageModeParam = QueryParameter.get("pagemode")?.toLowerCase();
        if (!Util.stringIsNullOrEmpty(pageModeParam)) {
            switch (pageModeParam) {
                case "dialog":
                    menuMode = "dialog";
                    break;

                case "parentchild":
                    contentMode = "parentchild";
                    break;
            }
        }

        if (this.currentContentMode != contentMode) {
            if (this.contentLayout) {
                this.contentLayout.dispose();
            }

            this.currentContentMode = contentMode;
            this.contentLayout = this.layoutProvider.getContentLayout(this.currentContentMode, this.layout, this.model);
            this.contentLayout.apply();
        }

        if (this.currentMenuMode != menuMode) {
            if (this.menuLayout) {
                this.menuLayout.dispose();
            }

            this.currentMenuMode = menuMode;
            this.menuLayout = this.layoutProvider.getMenuLayout(this.currentMenuMode, this.layout, this.model);
            this.menuLayout.apply();
        }
    }
}
